<template>
   <v-data-table v-bind:headers="headers" :items="itemList" item-key="id" :search="search"
       items-per-page-text="Lignes par page" hide-default-header :hide-default-footer="minView"
       :items-per-page-options="pagination.rowsPerItem">
       <template v-slot:top>
           <v-row class="rounded-lg ma-0 pa-0" v-show="!minView">
               <v-col cols="6" md="6" class="pa-1">
               <v-text-field append-icon="mdi-magnify" label="Recherche" outlined dense clearable single-line
                           hide-details v-model="search" class="pa-2 rounded-xl">
               </v-text-field>
               </v-col>
           </v-row>
       </template>
       <template v-slot:[`item.lst_tag`]="{ item }">
           <v-chip class="ma-2" color="primary" small>
               <v-icon left small>mdi-tag</v-icon>{{ item.lst_tag }}
           </v-chip>
           <span v-if="item.lst_name" class="font-weight-medium">{{ item.lst_name }}</span>
       </template>
       <template v-slot:[`item.lst_sex`]="{ item }">
           <v-chip class="ma-2" :color="item.lst_sex === 'M' ? 'blue' : 'pink'" small text-color="white">
               <v-icon left small>{{ item.lst_sex === 'M' ? 'mdi-gender-male' : 'mdi-gender-female' }}</v-icon>
               {{ item.lst_sex === 'M' ? 'Mâle' : 'Femelle' }}
           </v-chip>
       </template>
       <template v-slot:[`item.lst_typ_id`]="{ item }">
           <v-chip class="ma-2" color="grey lighten-2" small>{{ item.lst_typ_id }}</v-chip>
       </template>
       <template v-slot:[`item.lst_breed`]="{ item }">
           <span v-if="item.lst_breed">{{ item.lst_breed }}</span>
           <span v-else class="grey--text">-</span>
       </template>
       <template v-slot:[`item.lst_sta_id`]="{ item }">
           <v-chip class="ma-2" color="secondary" small>{{ item.lst_sta_id }}</v-chip>
       </template>
       <template v-slot:[`item.lst_id`]="{ item }">
           <v-btn v-if="$root.$permissions.Livestock && $root.$permissions.Livestock.update" rounded :href="'/#/livestocks/' + item.lst_id + ''" color="orange" elevation="0" dark small>
               <v-icon left small>mdi-pencil</v-icon> Fiche
           </v-btn>
       </template>
       <template v-slot:no-data>
       <v-alert :value="( !itemList.length )" color="error" icon="mdi-alert">
           Aucun animal enregistré
       </v-alert>
       </template>
   </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useLivestockStore } from '@/stores/livestock'

export default {
   name: 'livestocks-list',
   props: [ 'sitId', 'minView' ],
   computed: {
       ...mapState(useLivestockStore, {itemList: 'itemList' })
   },
   data: function () {
       return {
           search: '',
           pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
           headers: [
               { text: 'Identification', value: 'lst_tag', align: 'left'},
               { text: 'Espèce', value: 'lst_typ_id', align: 'left'},
               { text: 'Race', value: 'lst_breed', align: 'left'},
               { text: 'Sexe', value: 'lst_sex', align: 'center'},
               { text: 'Statut', value: 'lst_sta_id', align: 'left'},
               { text: 'Action', value: 'lst_id', align: 'right'},
           ],
       }
   },
   async mounted () {
    if( this.minView ){
        this.headers = [
            { text: 'Nom', value: 'lst_name', align: 'left'},
            { text: 'Race', value: 'lst_breed', align: 'left'},
            { text: 'Sexe', value: 'lst_sex', align: 'center'},
        ]
    }

    let params = '?per_page=false'
    params    += (this.sitId) ? '&extended=withsite&sit_id=' + this.sitId : ''
    await this.fetchItems(params)

   },
   methods: {
       ...mapActions(useLivestockStore, {fetchItems: 'fetchItems'}),
   },
}
</script>